<div class="po-details">
    <div class="modal-body">
        <div class="card p-3 mb-2 mt-3">
            <div class="row py-1">
                <div class="col-md-6">
                     <label class="form-label" >Vendor Code :</label>
                    <span>{{rowData?.vendorCode}}</span>
                </div>
                <div class="col-md-6">
                     <label class="form-label" >Vendor Name :</label>
                    <span>{{rowData?.vendorName}}</span>
                </div>
                <div class="col-md-6">
                     <label class="form-label" >Phone No :</label>
                    <span>{{rowData?.mobile}}</span>
                </div>
                <div class="col-md-6">
                     <label class="form-label" >Email :</label>
                    <span>{{rowData?.email}}</span>
                </div>
                <div class="col-md-6">
                     <label class="form-label" >WhatsApp Notification :</label>
                    <span>{{rowData?.vendorCode}}</span>
                </div>
                <div class="col-md-6">
                     <label class="form-label" >Pan No :</label>
                    <span>{{rowData?.vendorPan}}</span>
                </div>
                <div class="col-md-6">
                     <label class="form-label" >Vendor Address :</label>
                    <span>{{rowData?.addressLine1}} {{rowData?.cityName}} {{rowData?.districtName}}
                        {{rowData?.stateName}} {{rowData?.countryName}} {{rowData?.pincode}}
                    </span>
                </div>
                <div class="col-md-6">
                     <label class="form-label" >Vendor Code :</label>
                    <span>{{rowData?.vendorCode}}</span>
                </div>
                <div class="col-md-6">
                     <label class="form-label" >Vendor Code :</label>
                    <span>{{rowData?.vendorCode}}</span>
                </div>
                
            </div>



    </div>

    <div class="card p-3 mb-2 mt-3">
            <div class="row py-1">
                <div class="col-md-6">
                     <label class="form-label" >Contact Name :</label>
                    <span>{{rowData?.contactName}}</span>
                </div>
                <div class="col-md-6">
                     <label class="form-label" >Contact No. :</label>
                    <span>{{rowData?.contactMobile}}</span>
                </div>
                <div class="col-md-6">
                     <label class="form-label" >Alternate Contact No :</label>
                    <span>{{rowData?.contactAlternateMobile}}</span>
                </div>

                <div class="col-md-6">
                     <label class="form-label" >Contact Email :</label>
                    <span>{{rowData?.contactEmail}}</span>
                </div>


    </div>
</div>

</div>